
import router from '@/router/index';
let vehicleList = [{ id: 1, vehicleType: "abc", categoryName: "at1", seat: 1 }]
const state = {

    category: vehicleList,
    newVehicleCategory: {},
    editId: null
}
const getters = {
    CategoryList: state => state.category,
    vehicle: state => state.newVehicleCategory
};

const actions = {
    async getVehicle({ commit }) {

        commit('get', state.category)
    },
    async addCategory({ commit }, category) {

        commit('add', category)
    },
    async editCategoryr({ commit }, category) {

        commit('edit', category)
    },
    async updateCategory({ commit }, category) {
        commit('update', category)
    },
    async removeCategory({ commit }, category) {
        commit('remove', category)
    }
}
const mutations = {
    get(state, category) {

        state.CategoryList = category
    },
    add(state, newCategory) {
        newCategory.id = state.category.length + 1

        state.CategoryList.push(newCategory);
        router.push({ name: "vehicle-category", params: { add: true } });
    },
    edit(state, category) {
        state.editId = category.id
        state.newVehicleCategory = category
        router.push({ name: "VehicleCategoryForm", params: { add: false } });
    },
    update(state, category) {
        const index = state.CategoryList.map(item => item.id).indexOf(category.id)
        state.CategoryList[index] = category;
        router.push({ name: "vehicle-category", params: { add: false } });
    },
    remove(state, category) {

        const index = state.CategoryList.map(item => item.id).indexOf(category.id)
        state.CategoryList.splice(index, 1)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}